// src/pages/seller/FinancialsPage.jsx
import React from 'react';

const FinancialsPage = () => {
  const financialData = {
    monthlyRevenue: [
      { month: 'Jan', revenue: 12000 },
      { month: 'Feb', revenue: 15000 },
      { month: 'Mar', revenue: 18000 },
      { month: 'Apr', revenue: 22000 }
    ],
    settlements: [
      { id: 'SETTLE-001', date: '2025-03-31', amount: 14500, status: 'paid' },
      { id: 'SETTLE-002', date: '2025-02-28', amount: 11200, status: 'paid' }
    ]
  };

  return (
    <div>
      <h1 className="text-2xl font-medium text-gray-900 mb-6">Financials</h1>
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* 매출 요약 */}
        <div className="border border-gray-200 rounded-lg p-6">
          <h2 className="text-lg font-medium mb-4">Revenue Summary</h2>
          <div className="h-64 flex items-end gap-2">
            {financialData.monthlyRevenue.map((month, i) => (
              <div key={i} className="flex-1 bg-green-500 rounded-t" style={{ height: `${(month.revenue / 25000) * 100}%` }}></div>
            ))}
          </div>
          <div className="flex justify-between mt-2 text-sm text-gray-600">
            {financialData.monthlyRevenue.map((month, i) => (
              <span key={i}>{month.month}</span>
            ))}
          </div>
        </div>
        
        {/* 정산 내역 */}
        <div className="border border-gray-200 rounded-lg p-6">
          <h2 className="text-lg font-medium mb-4">Settlement History</h2>
          <div className="space-y-3">
            {financialData.settlements.map((settlement) => (
              <div key={settlement.id} className="flex justify-between items-center p-3 border border-gray-200 rounded">
                <div>
                  <p className="font-medium">Settlement #{settlement.id}</p>
                  <p className="text-sm text-gray-600">{settlement.date}</p>
                </div>
                <div className="text-right">
                  <p className="font-medium">${settlement.amount.toLocaleString()}</p>
                  <span className={`px-2 py-1 rounded-full text-xs ${
                    settlement.status === 'paid' ? 'bg-green-100 text-green-800' :
                    'bg-yellow-100 text-yellow-800'
                  }`}>
                    {settlement.status}
                  </span>
                </div>
              </div>
            ))}
          </div>
          
          <button className="w-full mt-4 bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700">
            Request Payout
          </button>
        </div>
      </div>
    </div>
  );
};

export default FinancialsPage;